import { createSlice } from "@reduxjs/toolkit";

const settlementDetailsSlice = createSlice({
  name: "settlementDetails",
  initialState: {
    user: null,
    unSettledAmount: 0,
    settledAmount: 0,
    leanAmount: 0,
  },
  reducers: {
    // Store settlement details (user and amounts)
    StoreSettlementDetails: (state, action) => {
      const { unSettledAmount, settledAmount, leanAmount } = action.payload;
      state.unSettledAmount = unSettledAmount;
      state.settledAmount = settledAmount;
      state.leanAmount = leanAmount;
    },

    ClearUser: (state) => {
      state.user = null;
    },
  },
});

export const { StoreSettlementDetails,  ClearUser } = settlementDetailsSlice.actions;

export default settlementDetailsSlice.reducer;
